import { render, staticRenderFns } from "./Afes.vue?vue&type=template&id=71c829de&scoped=true"
import script from "./Afes.vue?vue&type=script&lang=js"
export * from "./Afes.vue?vue&type=script&lang=js"
import style0 from "./Afes.vue?vue&type=style&index=0&id=71c829de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c829de",
  null
  
)

export default component.exports